export const MODIFY_PLANS_PAGES_TYPES = {
  MODIFY_PLAN: 'modifyPlan',
  CROSS_SELL: 'crossSell',
} as const

export type ModifyPlansPagesTypes =
  (typeof MODIFY_PLANS_PAGES_TYPES)[keyof typeof MODIFY_PLANS_PAGES_TYPES]
